import Vue from 'vue';
import { Button, Progress, Field, CellGroup, Cell, RadioGroup, Radio, DatetimePicker, Popup, Picker, IndexBar, IndexAnchor, Toast, Dialog, SwipeCell, Checkbox, CheckboxGroup, Search, Grid, GridItem, SwipeItem, Swipe } from 'vant';
// 全局注册
Vue.use(Button);
Vue.use(Progress);
Vue.use(Field);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(SwipeCell);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Search);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Swipe);
Vue.use(SwipeItem);


// WEBPACK FOOTER //
// ./src/vant/vant.js